import type { FC } from "react";
import { Link } from "@stubhub/broadway-web";
import { ChevronLeftIcon } from "@stubhub/broadway-web/icons/functional";
import { AddFeature } from "@viagogo/feature";
import { Content } from "src/shared/components/content";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { useAppContext } from "src/shared/context/AppContext";
import { usePerformerNativeHeader } from "src/website-apps/responsive/stubhub-performer/components/page-header/native-header/usePerformerNativeHeader";
import { nativeBackButton, nativeHeaderWrapper, placeholderDiv, sellTicketsLink } from "./styles";

interface Props {
  performerName: string;
}

export const PerformerNativeHeader: FC<Props> = ({ performerName }) => {
  const appContext = useAppContext();
  const {
    showWebHeaderForNativeApp,
    handleWebHeaderBackClick: handleClick,
    isPastScrollThreshold,
  } = usePerformerNativeHeader();

  if (!showWebHeaderForNativeApp) return null;

  const appearance = isPastScrollThreshold ? "opaque" : "transparent";

  return (
    <div className={nativeHeaderWrapper({ appearance })}>
      <button type="button" aria-label="Back" className={nativeBackButton({ appearance })} onClick={handleClick}>
        <ChevronLeftIcon size={16} />
      </button>
      {isPastScrollThreshold && performerName}
      <div className={placeholderDiv} />
      <AddFeature
        id={FeatureSetEnum.MPerformerSellDeeplink}
        feature={() => (
          <Link href={`/SellTickets/FindEvent/${appContext.categoryId}`} className={sellTicketsLink({ appearance })}>
            {/* Sell Tickets */}
            <Content id="cid$#3707470#" />
          </Link>
        )}
      />
    </div>
  );
};
